import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';


@Component({
  selector: 'app-openorders',
  templateUrl: './openorders.component.html',
  styleUrls: ['./openorders.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class OpenordersComponent implements OnInit {
  userDetails:any;
  userSessionData:any;
  public isCollapsed: boolean[] = [];
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('detailRow');
  expandedElement: any;
  read:any;
  write:any;
  delete:any;
  export:any
  showFilter:boolean=false
  dataSource: any;
  tableData: [] = [];
  showCustomisedSearch:boolean=false;
  searchValue:any;
  filterValueSelected:any
  displayedColumns = ['accountEmailId', 'vendorId', 'orderId','createdDate','button']
  dataSourceProductDetails:any;
  displayedColumnsProductDetails=['productName','productImage','description','productStatus','updatingQuantity']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  productImageId: any;
  myurl: string;
  constructor(private cs:CucurachaAdminService,private excelService: ExcelService) { 
    this.myurl = this.cs.endpoint;

  }
  filter() {
    this.getAllOpenOrders()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllOpenOrders();

  }
  viewImages(id:any){
    this.productImageId=id
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForOpenOrders(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)

      })
    }
    else {
      this.getAllOpenOrders()
    }
  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
 
  exportTable(){
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'OpenOrders');
    this.cs.exportLogAdd(this.userDetails.emailId, 'OpenOrders').subscribe((data) => {
    })
  }
  getAllProductDetailsByOrderId(id:any){
    this.cs.getAllProductDetailsByOrderId(id).subscribe((data)=>{
      console.log(data[0].productdetails.productName)

      this.dataSourceProductDetails = new MatTableDataSource(data)
      this.dataSourceProductDetails.sort = this.sort
      this.dataSourceProductDetails.paginator = this.paginator
    })

  }
  getAllOpenOrders(){
    this.cs.getAllOpenOrders().subscribe((data) => {
      this.dataSource = new MatTableDataSource(data)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  ngOnInit(): void {
    this.getAllOpenOrders()
    this.userSessionData = (JSON.parse(localStorage.getItem('user')))

    this.cs.getUserDataByEmailId(this.userSessionData).subscribe((data) => {
      this.userDetails=data[0]
      this.read=(this.userDetails.roledetails[0].components[0].component_name[0][0].openOrders_management.permissions[0].read);
      this.write=(this.userDetails.roledetails[0].components[0].component_name[0][0].openOrders_management.permissions[0].write)
      this.delete=(this.userDetails.roledetails[0].components[0].component_name[0][0].openOrders_management.permissions[0].delete)
      this.export=(this.userDetails.roledetails[0].components[0].component_name[0][0].openOrders_management.permissions[0].export)

    })

  }

}
